import react from 'react';
import { ActiveRecordContext } from '../components/contextProviders/ActiveRecord';
const { useContext } = react;

/**
 * Returns the record and form metadata currently displayed by ActiveRecord.
 * formInstanceId changes when ActiveRecord displays a different form.
 *
 * @returns  {{
 *   namespace: string,
 *   relation: string,
 *   type: string,
 *   isNew: boolean,
 *   record?: object,
 *   oldRecord?: object,
 *   activationVerb: string,
 *   formInstanceId: string
 * }}}
 */
export default function useActiveRecord() {
    return useContext(ActiveRecordContext);
}
